import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueCookies from 'vue-cookies';
import Vuetify from 'vuetify';
import 'vuetify/src/stylus/app.styl';
import JsonExcel from 'vue-json-excel';

import Popup from './components/globals/popup/popup'

require('dotenv').config({ path:'../../.env' })

window.$ = require('jquery');
window.jQuery = require('jquery');

var apiAddresses = {
	admin: process.env.VUE_APP_ADMIN_URL,
	blog: process.env.VUE_APP_BLOG_URL,
	courses: process.env.VUE_APP_COURSES_URL,
	events: process.env.VUE_APP_EVENTS_URL,
	newsletter: process.env.VUE_APP_NEWSLETTER_URL,
	contact: process.env.VUE_APP_CONTACT_URL,
	pages: process.env.VUE_APP_PAGES_URL,
	images: process.env.VUE_APP_IMAGES_URL,
	site: process.env.VUE_APP_SITE_URL,
	notifications: process.env.VUE_APP_NOTIFICATIONS_URL,
}
Vue.config.productionTip = false;
Vue.prototype.$myServerAddresses = apiAddresses;

router.beforeEach(( to, from, next ) => {
	if( to.matched.some( record => record.meta.requiresAuth ) )
	{
		var token = VueCookies.get('token');
		if( token ) {
			store.state.loggedIn = true;
			VueCookies.set('token',token,"1h");
			VueCookies.set('userId',VueCookies.get('userId'),"1h");
            VueCookies.set('tokenExpiration',VueCookies.get('tokenExpiration'),"1h");
            VueCookies.set('permission',VueCookies.get('permission'),"1h");
			next();
		}
		else {
			store.state.nextUrl = to.fullPath;
			next({
				path: '/login'
			});
		}
	}
	else {
		next();
	}
})

import pt from 'vuetify/es5/locale/pt'

Vue.component('downloadExcel', JsonExcel)
Vue.component('global-popup', Popup)
Vue.use( VueCookies )
Vue.use( Vuetify, {
	lang: {
		locales: { pt }
	},
	current: 'pt'
})

import 'vuetify/dist/vuetify.min.css'

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
